// src/components/InstitutionalSchedulePage.jsx
import React, { useMemo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LiveScheduleView from './LiveScheduleView'; // Correct path
import { setLastInstitutionUrlEndpoint } from '../utils/lastInstitutionUrlEndpoint';
import { getPublicScheduleShareMeta } from '../services/apiService';

const InstitutionalSchedulePage = ({ user, teachers, groups, subjects, rooms, isAssetsLoading = false, onAddGroup }) => {
    const { institutionUrlEndpoint, scheduleShareSlug } = useParams();
    const [scheduleShareMeta, setScheduleShareMeta] = useState(null);

    console.log('[InstitutionalSchedulePage] Rendering for endpoint:', institutionUrlEndpoint);

    const filters = useMemo(() => {
        return {};
    }, []);

    const include = useMemo(() => (
        'subject,teacher,group,room'
    ), []);

    useEffect(() => {
        if (institutionUrlEndpoint && !scheduleShareSlug) {
            setLastInstitutionUrlEndpoint(institutionUrlEndpoint);
        }
    }, [institutionUrlEndpoint, scheduleShareSlug]);

    useEffect(() => {
        let mounted = true;
        if (!scheduleShareSlug) {
            setScheduleShareMeta(null);
            return () => { mounted = false; };
        }

        setScheduleShareMeta(null);
        getPublicScheduleShareMeta(scheduleShareSlug)
            .then((meta) => {
                if (mounted) setScheduleShareMeta(meta);
            })
            .catch((error) => {
                console.error('[InstitutionalSchedulePage] Failed to load shared schedule metadata:', error);
            });

        return () => { mounted = false; };
    }, [scheduleShareSlug]);

    return (
        <div>
            <LiveScheduleView
                user={user}
                teachers={teachers}
                groups={groups}
                subjects={subjects}
                rooms={rooms}
                isAssetsLoading={isAssetsLoading}
                filters={filters}
                include={include}
                isPublicView={true}
                isScheduleShare={!!scheduleShareSlug}
                scheduleShareMeta={scheduleShareMeta}
                scheduleShareSlug={scheduleShareSlug}
                onAddGroup={onAddGroup}
            />
        </div>
    );
};

export { InstitutionalSchedulePage };
